import React, { useState } from 'react';
import { SingleDatePicker } from 'react-dates';

import './mobile-day-picker.scss';

function MobileDayPicker({ date, setDate }) {
  const [focused, setFocused] = useState(null);

  return (
    <div className="mobile-day-picker">
      <SingleDatePicker
        date={date}
        onDateChange={d => setDate(d)}
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        // Calendar options
        displayFormat="MM/DD/YY"
        numberOfMonths={1}
        hideKeyboardShortcutsPanel={true}
        transitionDuration={0}
        placeholder="Select Date"
        isOutsideRange={() => false}
        id="mobile-day-picker"
      />
    </div>
  );
}

export default MobileDayPicker;
